// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","label":"label-BG7FZ","container":"container-2iW3c"};